import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { trackPage } from '../utils/analytics';

export default function Landing() {
  const [teaser, setTeaser] = useState(null);

  useEffect(() => {
    trackPage('/');
    fetchTeaser();
  }, []);

  async function fetchTeaser() {
    // Fetch approved profiles with photos, pick one at random
    const { data } = await supabase
      .from('profiles')
      .select('id, display_name, profile_photo_url, total_ratings_received')
      .eq('photo_approved', true)
      .not('profile_photo_url', 'is', null)
      .gte('current_score', 6.0)  // only show reasonably rated profiles
      .order('total_ratings_received', { ascending: false })
      .limit(20);

    if (data && data.length > 0) {
      const random = data[Math.floor(Math.random() * data.length)];
      setTeaser(random);
    }
  }

  return (
    <div className="page" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '100px 20px 60px' }}>
      <div className="container">

        {/* Hero title — no .com */}
        <div style={{ marginBottom: 8 }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(3rem, 10vw, 6rem)', lineHeight: 1 }}>
            <span style={{ color: 'var(--gold)' }}>valid</span>
            <span style={{ color: 'var(--text-muted)', fontSize: '60%' }}> or </span>
            <span style={{ color: 'var(--purple-light)' }}>mid</span>
          </h1>
        </div>

        <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', letterSpacing: '0.06em', marginBottom: 48 }}>
          The internet's most honest opinion. Since today.
        </p>

        <div className="divider">+</div>

        {/* Value props */}
        <div style={{ display: 'grid', gap: 12, margin: '32px 0', textAlign: 'left' }}>
          {[
            'Upload one photo. That\'s it.',
            'The internet delivers its verdict.',
            'Your score reflects who\'s judging you.',
          ].map((text) => (
            <div key={text} style={{
              background: 'var(--card-bg)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius)',
              padding: '12px 20px',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}>
              <span style={{ color: 'var(--purple-light)', fontFamily: 'var(--font-heading)', fontSize: '1.4rem', lineHeight: 1 }}>›</span>
              <span style={{
                color: 'var(--text)',
                fontFamily: 'var(--font-heading)',
                fontSize: '1.4rem',
                letterSpacing: '0.02em',
                lineHeight: 1.2,
              }}>{text}</span>
            </div>
          ))}
        </div>

        <Link to="/register">
          <button className="btn-primary" style={{ fontSize: '1.1rem', padding: '16px 40px' }}>
            Join the judgment
          </button>
        </Link>

        <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', marginTop: 16 }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: 'var(--purple-light)', textDecoration: 'none' }}>
            Sign in
          </Link>
        </p>

        <div className="divider" style={{ marginTop: 48 }}>+</div>

        {/* Teaser section */}
        <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', marginTop: 24, marginBottom: 16, letterSpacing: '0.06em' }}>
          What would you say?
        </p>

        {teaser ? (
          <>
            {/* Live teaser photo card */}
            <div style={{
              background: 'var(--card-bg)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius-lg)',
              overflow: 'hidden',
              boxShadow: 'var(--glow-purple)',
              position: 'relative',
            }}>
              <img
                src={teaser.profile_photo_url}
                alt="Preview profile"
                style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', display: 'block' }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0, left: 0, right: 0,
                height: '40%',
                background: 'linear-gradient(to top, rgba(13,13,13,0.95), transparent)',
                pointerEvents: 'none',
              }} />
              <div style={{
                position: 'absolute',
                bottom: 16, left: 20,
                fontFamily: 'var(--font-heading)',
                fontSize: '1.6rem',
                color: 'var(--text)',
              }}>
                {teaser.display_name}
              </div>
            </div>

            {/* Teaser verdict buttons */}
            <div className="verdict-buttons" style={{ marginTop: 16 }}>
              <Link to="/register" style={{ textDecoration: 'none' }}>
                <button className="btn-valid" style={{ width: '100%' }}>Valid</button>
              </Link>
              <Link to="/register" style={{ textDecoration: 'none' }}>
                <button className="btn-mid" style={{ width: '100%' }}>Mid</button>
              </Link>
            </div>
          </>
        ) : (
          /* Loading skeleton */
          <div style={{
            background: 'var(--card-bg)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-lg)',
            aspectRatio: '1/1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--text-muted)',
            fontFamily: 'var(--font-heading)',
            fontSize: '1.2rem',
          }}>
            Loading...
          </div>
        )}

        <p style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: 16, lineHeight: 1.6 }}>
          Sign up to cast your verdict. It's free.
        </p>

      </div>
    </div>
  );
}
